export var ObjectType;
(function (ObjectType) {
    ObjectType["line"] = "line";
    ObjectType["oval"] = "oval";
    ObjectType["polygon"] = "polygon";
    ObjectType["text"] = "text";
    ObjectType["vband"] = "vband";
    ObjectType["vertical"] = "vertical";
    ObjectType["horizon"] = "horizon";
    ObjectType["errorBar"] = "errorbar";
})(ObjectType || (ObjectType = {}));
//# sourceMappingURL=object.js.map